// extracted by mini-css-extract-plugin
module.exports = {"link":"DuplicateApplicationErrorNotification_link__PYj5z"};